import { useGetData, UseGetDataResultReturnType } from "@/component/PageComponent/hooks/requst"
import { CardModule, CustomReportConfig } from "@/component/common/report/reportConfigModel"
import { Card, Col, Flex, Row } from "antd"
import React from "react"
import styled from "styled-components"
import { serviceQuickBiReportDataMobile } from "../services/bi/bi"
import { isError } from "@/component/common/error"
import { ColProps } from 'antd'
import _, { extend } from "lodash"
import { ReportConfig,ReportParams } from "@/component/common/report/report"
import { FORMAT_STRING, numberThousandSeparatorByValueType } from "@/component/Report/share/numberFormat"
import { useCustomCardHooks } from "@/component/ReportCommon/CustomCard/CustomCard"
import { isErrorMobile } from "@/component/PageComponentMobile/error"

const CardStyled = styled.div`
  width: 100%;
  .content{
    /* display: flex;
    flex-wrap: wrap; */
    padding: 15px;
    .item{
      height: 30px;
      display: flex;
      align-items: center;
      .lable{
        color: #999999;
        margin-right: 10px;
      }
      .relative—ratio{
        margin-left: 10px;
      }
    }
  }
`

interface sortParams{
  dataIndex:string
  order:string
}

interface CustomCardProps {
  reportConfig: ReportConfig,
  moduleItem: CardModule
  dataHandler: UseGetDataResultReturnType<ReportParams> 
  style?: React.HTMLAttributes<'div'>['style']
}

export function CustomCard(props: CustomCardProps) {
  const {  list,cardInfo } = useCustomCardHooks({
    ...props,
    getBiReportCardData:async (params)=>{
      let res = await serviceQuickBiReportDataMobile(params)
      return res
    },
    isError: isErrorMobile
  })
  console.log(cardInfo,list,'card')
  if (!cardInfo) {
    return null
  }
  return <CardStyled>
    <div className="content">
      {
        list.map((item,index)=>{
          let relateiveContent = item.hideRelativeRatio ? '' : <span className="relative—ratio">(环比: {item.relativeRatio}%)</span>
          return <div className="item" key={index}>
            <span className="lable">{ item.name }:</span> <span className="value">{item.value}</span> { relateiveContent }
          </div>
        })
      }
    </div>
  </CardStyled>
}